/* Step 11c-3 · lane C3a (Mars live finds, 01-Nov-2026) — EN + AR texts.
   s11c3Inv  find 28: the inventory count worksheet's editable floor-to-sheet rows (components/InventoryFloorRows.jsx).
   s11c3Rp   find 33: the related-party "Scan GL" result grouped by party (components/RpScanResult.jsx);
             find 35: the type and the exception's amount chosen on "Send to misstatements" (components/RpSendException.jsx).
   s11c3Op   find 38: 318(a) "Opinion type concluded" — the four opinion types, kept in step with the summary memo
             (components/forms/FormRenderer.jsx). */
export default {
  en: {
    s11c3Inv: {
      save: "Save",
      delete: "Delete",
      discard: "Discard",
      saved: "Row saved",
      deleted: "Row deleted",
      confirmDelete: "Delete this floor-to-sheet row?",
      none: "No floor-to-sheet rows yet — use “Add floor-to-sheet row”.",
      newHint: "Fill in the new row, then press Save on it. An empty row is not saved.",
    },
    s11c3Rp: {
      scanSummary: "{lines} GL lines in {vouchers} vouchers for {parties} parties (current period) · Debit {debit} · Credit {credit}",
      scanCapped: "Showing the first {shown} of {total} lines (earliest first in each party). Open a party to see its lines.",
      scanOutdated: "This scan was run before the current-period rule and includes prior-year lines. Press “Scan GL” again.",
      partyMore: "{shown} of {total} lines shown.",
      lines: "Lines",
      vouchers: "Vouchers",
      debit: "Debit",
      credit: "Credit",
      dates: "First – last date",
      type: "Type",
      amount: "Exception amount",
      amountHint: "The misstatement in this exception — not the year's total transactions with the party.",
      disclosureNote: "A disclosure item has no amount effect (0.00).",
      send: "Send",
      cancel: "Cancel",
      types: { Factual: "Factual", Judgmental: "Judgmental", Disclosure: "Disclosure" },
    },
    s11c3Op: {
      opinion: { unmodified: "Unmodified", qualified: "Qualified", adverse: "Adverse", disclaimer: "Disclaimer of opinion" },
      fromMemo: "Shown from the Audit summary memo's proposed opinion. Saving this form keeps both the same.",
    },
  },
  ar: {
    s11c3Inv: {
      save: "حفظ",
      delete: "حذف",
      discard: "تجاهل",
      saved: "تم حفظ الصف",
      deleted: "تم حذف الصف",
      confirmDelete: "حذف صف الاختبار من الأرض إلى الكشف هذا؟",
      none: "لا توجد صفوف من الأرض إلى الكشف بعد — استخدم «إضافة صف من الأرض إلى الكشف».",
      newHint: "أدخل بيانات الصف الجديد ثم اضغط «حفظ» عليه. لا يُحفظ صف فارغ.",
    },
    s11c3Rp: {
      scanSummary: "{lines} سطراً في الأستاذ ضمن {vouchers} سنداً لعدد {parties} من الأطراف (الفترة الحالية) · مدين {debit} · دائن {credit}",
      scanCapped: "تُعرض أول {shown} سطراً من أصل {total} (الأقدم أولاً لكل طرف). افتح الطرف لعرض سطوره.",
      scanOutdated: "أُجري هذا الفحص قبل قاعدة الفترة الحالية ويتضمن سطور السنة السابقة. اضغط «فحص الأستاذ» مرة أخرى.",
      partyMore: "عُرض {shown} من أصل {total} سطراً.",
      lines: "السطور",
      vouchers: "السندات",
      debit: "مدين",
      credit: "دائن",
      dates: "أول – آخر تاريخ",
      type: "النوع",
      amount: "مبلغ الاستثناء",
      amountHint: "التحريف في هذا الاستثناء — لا إجمالي معاملات السنة مع الطرف.",
      disclosureNote: "بند الإفصاح ليس له أثر على المبالغ (0.00).",
      send: "إرسال",
      cancel: "إلغاء",
      types: { Factual: "فعلي", Judgmental: "تقديري", Disclosure: "إفصاح" },
    },
    s11c3Op: {
      opinion: { unmodified: "غير معدّل", qualified: "متحفظ", adverse: "معاكس", disclaimer: "الامتناع عن إبداء الرأي" },
      fromMemo: "معروض من الرأي المقترح في مذكرة ملخص المراجعة. حفظ هذا النموذج يُبقي الاثنين متطابقين.",
    },
  },
};
